module.exports = __webpack_public_path__ + "img/off_tackle_left.615b71fc.jpg";